package com.iregained.site.components.sections.clinicians.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val CliniciansFaqContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().nearBackground)
}

val CliniciansFaqWrapperStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(800.px)
}

val CliniciansFaqItemStyle = CssStyle.base {
    Modifier.fillMaxWidth().margin(bottom = 16.px).backgroundColor(Colors.White).borderRadius(8.px)
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().custom.divider)
        .overflow(com.varabyte.kobweb.compose.css.Overflow.Hidden)
}

val CliniciansFaqHeaderStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(24.px).cursor(Cursor.Pointer)
}

val CliniciansFaqQuestionTextStyle = CssStyle.base {
    Modifier.fontSize(18.px).transition(Transition.of("color", 200.ms))
}

val CliniciansFaqToggleIconStyle = CssStyle.base {
    Modifier.fontSize(24.px).color(colorMode.toSitePalette().brand.primary).fontWeight(FontWeight.Bold)
}

val CliniciansFaqAnswerBoxStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(leftRight = 24.px, top = 0.px, bottom = 24.px)
}

val CliniciansFaqAnswerTextStyle = CssStyle.base {
    Modifier.fontSize(16.px).color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f))
        .lineHeight(1.6)
}